import { render } from "./MatrixLimos.vue?vue&type=template&id=b53f20e0&scoped=true"
import script from "./MatrixLimos.vue?vue&type=script&lang=js"
export * from "./MatrixLimos.vue?vue&type=script&lang=js"

import "./MatrixLimos.vue?vue&type=style&index=0&id=b53f20e0&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/Israr/vue/matrixlimos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b53f20e0"]])

export default __exports__